export function safeHttpsUrl(value) {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password
      ? url.href
      : null;
  } catch {
    return null;
  }
}
// The monitored inbox: a Google Workspace group reaching both founders.
// REACT_APP_PILOT_EMAIL still overrides it for a preview build.
export const CONTACT_EMAIL = "info@vecturf.co.uk";
const email = (process.env.REACT_APP_PILOT_EMAIL || CONTACT_EMAIL).trim();
const validEmail = /^[^\s@?&#]+@[^\s@?&#]+\.[^\s@?&#]+$/.test(email);
const contactUrl = safeHttpsUrl(process.env.REACT_APP_PILOT_CONTACT_URL);
export const siteConfig = {
  appUrl:
    safeHttpsUrl(process.env.REACT_APP_APPLICATION_URL) ||
    "https://app.vecturf.co.uk/login",
  enquiryUrl:
    contactUrl ||
    (validEmail
      ? `mailto:${email}?subject=${encodeURIComponent("Exploring a VecTurf pilot")}`
      : null),
  contactEmail: validEmail ? email : null,
  enquiryLabel: contactUrl
    ? "Arrange a conversation"
    : "Email us about your course",
};
